<div class="bg-div">
    <!-- side bar -->
    <div class="side-menu">
        <img src="../../assets/side_cut_2.svg" class="image-styling dsk" alt="">
        <div class="side-bar-icon-container-up side-menu-div">
            <span (click)="previous()" class="material-icons side-icon">arrow_circle_up</span>
        </div>
        <div class="center-dots side-menu-div">
            <div class="mb logo">
                <img src="../../assets/Incubator.png" alt="AII" class="mb-aii-logo">
            </div>
            <div style="flex:1"></div>
            <div class="mb-dots dot-cont" id="dot-con">
                <div class="circle" id="one"></div>
                <div class="circle" id="spacer" style="background-color: transparent;"></div>
                <div class="circle" id="two"></div>
            </div>
            <div style="flex:1"></div>
        </div>
        <div class="side-bar-icon-container-down side-menu-div">
            <span (click)="next()" class="material-icons side-icon">arrow_circle_down</span>
        </div>
    </div>
    <!-- form -->
    <div class="form-div">

        <img src="../../assets/Incubator.svg" alt="AII" class="aii-logo dsk">

        <h1 *ngIf="activeSection==1" class="heading">About Startup</h1>
        <h1 *ngIf="activeSection==2" class="heading">Contact Details</h1>

        <form [formGroup]="startupData" (ngSubmit)="submit()">

            <!-- section one -->
            <div *ngIf="activeSection==1" class="form-margin">

                <div class="container-fluid">
                    <div class="row row-custom-padding">

                        <mat-form-field class="full-width form-area">
                            <!-- <mat-label>Startup Name*</mat-label> -->
                            <label class="input-label req">STARTUP NAME</label>
                            <input matInput formControlName="sName">
                        </mat-form-field>

                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <!-- <mat-label>Industry</mat-label> -->
                                <label class="input-label req">INDUSTRY</label>
                                <mat-select formControlName="sIndustry" (selectionChange)="getSectorsList()">
                                    <mat-option *ngFor="let e of industries" [value]="e.text">{{e.text}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">

                            <mat-form-field class="full-width form-area">
                                <!-- <mat-label>Sector</mat-label> -->
                                <label class="input-label req">SECTOR</label>
                                <mat-select formControlName="sSector">
                                    <mat-option *ngFor="let e of sectors" [value]="e.text">{{firstCap(e.text)}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6" style="display: flex;
                        flex-direction: column;
                        justify-content: space-between;">
                            <div class="form-area">
                                <label class="input-label req">STAGE</label>
                                <mat-button-toggle-group class="stage" #group id="group" formControlName="stage"
                                    [ngClass]="{'force-warn':stageWarn}">
                                    <mat-button-toggle value="ideation" aria-label="Text align left">
                                        Ideation
                                    </mat-button-toggle>
                                    <mat-button-toggle value="validation" aria-label="Text align center">
                                        Validation
                                    </mat-button-toggle>
                                    <mat-button-toggle value="earlyTraction" aria-label="Text align right">
                                        Early Traction
                                    </mat-button-toggle>
                                    <mat-button-toggle value="scaling" aria-label="Text align justify">
                                        Scaling
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>

                            <div class="form-area switch" style="display: flex;
                            flex-direction: column;
                            justify-content: center;">
                                <div style="display: flex;border: 1px solid #989898;
                                border-radius: 50px;
                                padding: 2px ;width: fit-content; position: relative; margin: auto;">
                                    <!-- <label class="input-label" style="margin-right: 4px;">FUNDED</label>
                                    <input type="checkbox" id="customSwitch1"
                                        style="margin-left: 8px; margin-right: 8px;cursor:pointer"
                                        formControlName="fundOrBoot">
                                    <label class="input-label req" style="margin-left: 4px;">BOOTSTRAP</label> -->
                                    <div class="pill" id="fund" (click)="changeType('funded')" style="color: white;">
                                        BOOTSTRAPED
                                    </div>
                                    <div class="pill active-pill" id=active></div>
                                    <div class="pill" id="boot" (click)="changeType('bootstrap')">
                                        FUNDED
                                    </div>
                                </div>
                            </div>

                            <div style="justify-content: space-between;display: flex;flex-direction: row;">
                                <div class="form-area" style="flex: 1;">
                                    <label class="input-label req"
                                        [ngClass]="{'force-warn-label':interestWarn}">INTERESTS</label>
                                    <div class="form-group col" formGroupName="sInterest"
                                        style="margin: 0; padding: 0; height: 82%;">
                                        <!-- <label for="">Interests*</label> -->
                                        <div
                                            style="display: flex; flex-direction: column;justify-content: space-between; height: 100%;">
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input class="custom-control-input" type="checkbox" id="Check1"
                                                    formControlName="all">
                                                <label style="cursor:pointer" class="custom-control-label" for="Check1"
                                                    (click)="checkAll()">All</label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input class="custom-control-input" type="checkbox" id="Check3"
                                                    formControlName="incubation" (change)="processAll(3)">
                                                <label style="cursor:pointer" class="custom-control-label"
                                                    for="Check3">Incubation</label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input class="custom-control-input" type="checkbox" id="Check4"
                                                    formControlName="acceleration" (change)="processAll(4)">
                                                <label style="cursor:pointer" class="custom-control-label"
                                                    for="Check4">Acceleration</label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input class="custom-control-input" type="checkbox" id="Check5"
                                                    formControlName="investment" (change)="processAll(5)">
                                                <label style="cursor:pointer" class="custom-control-label"
                                                    for="Check5">Investment</label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input class="custom-control-input" type="checkbox" id="Check2"
                                                    formControlName="mentoring" (change)="processAll(2)">
                                                <label style="cursor:pointer" class="custom-control-label"
                                                    for="Check2">Mentoring</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-area" style="flex: 1;">
                                    <label for="logoinput" class="input-label"
                                        style="display: flex; flex-direction:column; cursor: pointer; width: fit-content;"
                                        (mouseenter)="mouseEnter('logo') " (mouseleave)="mouseLeave('logo')">
                                        <span style="margin-bottom: .5em;">LOGO:</span>
                                        <span class="tool-tip" id="logo">Allowed Extensions png, jpeg, svg, ico,
                                            jpg<br>Max File Size: 2MB</span>
                                        <img [src]="logoBase64" alt="" class="upload-img">
                                    </label>
                                    <input type="file" id="logoinput" style="display: none;" #logoinput
                                        accept=".png,.jpeg,.svg,.ico,.jpg" (change)="uploadLogo(logoinput.files)">

                                </div>
                            </div>

                        </div>
                        <div class="col-md-6">

                            <div class="form-area"
                                style="display: flex; flex-direction: column; margin-bottom: 0px; height: 100%;">
                                <label class="input-label req" for="brief">ABOUT STARTUP</label>
                                <textarea [ngClass]="{'force-warn':briefWarn}" id="brief" formControlName="sBrief"
                                    maxlength="1200" #brief (keyup)="changeCharCount(brief.value)"></textarea>
                                <p style="text-align: right;">{{1200-textCount}}</p>
                            </div>

                        </div>
                    </div>


                </div>

            </div>

            <!-- section two -->
            <div *ngIf="activeSection==2" class="form-margin">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">FIRST NAME</label>
                                <input matInput formControlName="sFname">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">LAST NAME</label>
                                <input matInput formControlName="sLname">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">EMAIL</label>
                                <input matInput formControlName="sEmail" type="email">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">MOBILE</label>
                                <input matInput formControlName="sMobile" type="tel">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">STATE</label>
                                <mat-select formControlName="sState" (selectionChange)="stateSelected()">
                                    <mat-option *ngFor="let e of states" [value]="e.text">{{e.text}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label req">CITY</label>
                                <mat-select formControlName="sCity">
                                    <mat-option *ngFor="let e of cities" [value]="e.text">{{e.text}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label">WEBSITE</label>
                                <input matInput formControlName="sWebsite">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="full-width form-area">
                                <label class="input-label">MOBILE APP LINK</label>
                                <input matInput formControlName="sAppLink">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-custom-padding" style="width: 100%;">
                            <!-- <label for="pitch">
                                UPLOAD PITCH DECK:
                                <img [src]="pitchBase64" alt="" style="width: 80px; margin-left: 24px;">
                            </label> -->
                            <label for="pitchinput" class="input-label"
                                style="display: flex; flex-direction:column; cursor: pointer; width: 100%; position: relative;"
                                (mouseenter)="mouseEnter('pitch') " (mouseleave)="mouseLeave('pitch')">
                                <span class="req" style="margin-bottom: .5em;">PITCH DECK:</span>
                                <span class="tool-tip" id="pitch">Allowed Extensions pdf, pptx, ppt<br>Max
                                    File Size: 5MB</span>
                                <!-- <label>PITCH DECK:</label> -->
                                <div class="mb-dsk-flex">
                                    <!-- <div style="width: 20%;"> -->
                                    <img id="non-uploaded" [src]="pitchBase64" alt="" class="upload-img pitchPlace"
                                        *ngIf="!pitchChanged">
                                    <img id="pdf" [src]="pitchBase64" alt="pdf" class="upload-img" *ngIf="pitchChanged"
                                        style="width: 50px; ">
                                    <!-- </div> -->

                                    <div>
                                        <a href="https://drive.google.com/file/d/1l1jO5fGgjAjo9Nzg0leW6c-VK6zEOM2B/view?usp=sharing"
                                            rel="noopener noreferrer" class="pitch-deck-i" target="_blank">
                                            <img src="../../assets/information-2.svg" alt="" style="width: 12px;
                                        height: 17px;">
                                            <p style="padding: 0;font-size: 12px;margin: 0;margin-left: 6px;">
                                                Wondering about what details to mention in the Pitch Deck! Take a look
                                                at
                                                the<strong> <u> Sample
                                                        Pitch Deck.</u>
                                                </strong></p>
                                        </a>
                                        <p *ngIf="pitchBase64=='../../assets/upload/Error_upload.svg'" style="font-size: 14px;
                                            margin-left: 12px;
                                            color: red;
                                            font-weight: bold;
                                            margin-top: 8px;">
                                            Please upload a .pdf,.pptx,.ppt file only.</p>
                                    </div>
                                </div>
                            </label>
                            <input type="file" id="pitchinput" #pitchinput (change)="pitchUpload(pitchinput.files)"
                                accept=".pdf,.pptx,.ppt" style="display: none;">




                        </div>

                    </div>

                </div>
            </div>

            <div class="actions" style="cursor: pointer;"
                [ngClass]="{disabledCursor:(!this.checkFileUploads()||!startupData.valid)}">
                <button *ngIf="activeSection!=2" type="button" class="theme-btn" style="padding-left: 24px;
                padding-right: 15px;
                padding-top: 12px;
                padding-bottom: 10px;" (click)="next()">Continue <span style="vertical-align: middle;"
                        class="material-icons">
                        keyboard_arrow_right
                    </span> </button>
                <button *ngIf="activeSection==2" type="submit" class="theme-btn"
                    [ngClass]="{disabledBtn:(!checkFileUploads()||!startupData.valid)}">
                    <div class="sninner-cont" *ngIf="progressSpinner">
                        <mat-spinner diameter="20"></mat-spinner>
                    </div>
                    <ng-container *ngIf="!progressSpinner">
                        Submit
                    </ng-container>
                </button>
            </div>

            <div id="snack" class="msg" style="margin: auto;padding-top: 24px;">{{message}}</div>

        </form>

    </div>

</div>